import React, { useRef, useEffect } from 'react';
import './SmartStore.css';

function SmartStore() {
  const products = [
    {
      id: 1,
      imageUrl: "/stock-1.jpg",
      name: "(수입 S당일배송) 데져트 뮤즈 일루미네이크 드레이프 비스코스 맥시 롱 원피스",
      price: "338,540원",
      discount: "10%",
      link: "https://smartstore.naver.com/tong-is/products/12065088681"
    },
    {
      id: 2,
      link: "https://smartstore.naver.com/tong-is/products/12065027521",
      imageUrl: "/stock-2.jpg",
      name: "(수입 S당일배송) 더 스틸 그레이스 민소매 탑 맥시 스커트 새틴 투피스",
      price: "55,200원",
      discount: "14%"
    },
    {
      id: 3,
      link: "https://smartstore.naver.com/tong-is/products/12064963429",
      imageUrl: "/stock-3.jpg",
      name: "(수입 S당일배송) 라일락 바이올렛 플로럴 실크 테슬 벨티드 맥시 롱 원피스",
      price: "276,210원",
      discount: "10%"
    },
    {
      id: 4,
      link: "https://smartstore.naver.com/tong-is/products/12064944413",
      imageUrl: "/stock-4.jpg",
      name: "(수입제작 XS당일배송) 라벤더 실크 플로럴 미니원피스",
      price: "248,580원",
      discount: "10%"
    },
    {
      id: 5,
      link: "https://smartstore.naver.com/tong-is/products/12064913990",
      imageUrl: "/stock-5.jpg",
      name: "(수입 S당일배송) 아이시 민트 뮤즈 스판 캡소매 반넥 티",
      price: "17,730원",
      discount: "10%"
    }
  ];

  const handleProductClick = (e, link) => {
    if (hasMoved.current) {
      e.preventDefault();
      return;
    }
    window.open(link, '_blank', 'noopener,noreferrer');
  };

  // Triplicate products for seamless infinite loop
  const triplicatedProducts = [...products, ...products, ...products];
  const scrollRef = useRef(null);
  const isHovered = useRef(false);
  const isDragging = useRef(false);
  const hasMoved = useRef(false);
  const startX = useRef(0);
  const scrollLeftStart = useRef(0);

  const handleMouseDown = (e) => {
    isDragging.current = true;
    hasMoved.current = false;
    startX.current = e.pageX - scrollRef.current.offsetLeft;
    scrollLeftStart.current = scrollRef.current.scrollLeft;
  };

  const handleMouseUp = () => {
    isDragging.current = false;
  };

  const handleMouseLeave = () => {
    isHovered.current = false;
    isDragging.current = false;
  };

  const handleMouseMove = (e) => {
    if (!isDragging.current) return;

    const x = e.pageX - scrollRef.current.offsetLeft;
    if (Math.abs(x - startX.current) > 5) {
      hasMoved.current = true;
    }

    if (hasMoved.current) {
      e.preventDefault();
      const walk = (x - startX.current) * 1.5; // Drag speed multiplier
      scrollRef.current.scrollLeft = scrollLeftStart.current - walk;
    }
  };

  useEffect(() => {
    const container = scrollRef.current;
    if (!container) return;

    let animationFrameId;
    let accumulatedScroll = 0;

    // ✨ 애니메이션 속도 조절 
    // 숫자가 클수록 빠릅니다. (예: 0.5 = 기본, 1.0 = 2배 빠름, 0.2 = 느림)
    const SCROLL_SPEED = 0.3; 

    const animate = () => {
      if (container) {
        const singleSetWidth = container.scrollWidth / 3;

        if (container.scrollLeft >= singleSetWidth * 2) {
          container.scrollLeft -= singleSetWidth;
        } else if (container.scrollLeft <= 0) {
          container.scrollLeft += singleSetWidth;
        }

        if (!isHovered.current) {
          accumulatedScroll += SCROLL_SPEED;
          if (accumulatedScroll >= 1) {
            const intScroll = Math.floor(accumulatedScroll);
            container.scrollLeft += intScroll;
            accumulatedScroll -= intScroll;
          }
        }
      }
      animationFrameId = requestAnimationFrame(animate);
    };

    animationFrameId = requestAnimationFrame(animate);

    return () => cancelAnimationFrame(animationFrameId);
  }, []);

  return (
    <div className="smart-store-container section-container">
      <div 
        className="products-wrapper"
        ref={scrollRef}
        onMouseEnter={() => { isHovered.current = true; }}
        onMouseLeave={handleMouseLeave}
        onTouchStart={() => { isHovered.current = true; }}
        onTouchEnd={() => { isHovered.current = false; }}
        onMouseDown={handleMouseDown}
        onMouseUp={handleMouseUp}
        onMouseMove={handleMouseMove}
      >
        <div className="products">
          {triplicatedProducts.map((product, index) => (
            <div 
              key={`${product.id}-${index}`} 
              className="product" 
              onClick={(e) => handleProductClick(e, product.link)}
              style={{ cursor: 'pointer' }}
            >
              <img src={product.imageUrl} alt={product.name} draggable="false" />
              <p className="product-name">{product.name}</p>
              <p className="product-price">
                  {product.discount && <span className="discount">{product.discount}</span>}
                  {product.price}
              </p>
            </div>
          ))}
        </div>
      </div>
      <img src="/img-smart-store-logo.png" alt="스마트스토어" className="smart-store-logo" />
    </div>
  );
}

export default SmartStore;
